<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 24 24"
  fill="none"
  focusable="false"
  aria-hidden="true"
>
  <path
    [attr.fill]="fillColor"
    d="M21.643 6.044a1 1 0 0 0 0-1.696L16.53 1.152A1 1 0 0 0 15 2v6.392a1 1 0 0 0 1.53.848l5.113-3.196ZM2.47 19.044a1 1 0 0 1 0-1.696l5.113-3.196a1 1 0 0 1 1.53.848v6.392a1 1 0 0 1-1.53.848L2.47 19.044Z"
  />
  <path
    [attr.fill]="fillColor"
    d="M3 11a7 7 0 0 1 7-7h5a1 1 0 1 1 0 2h-5a5 5 0 0 0-5 5 1 1 0 1 1-2 0ZM20 12a7 7 0 0 1-7 7H8a1 1 0 1 1 0-2h5a5 5 0 0 0 5-5 1 1 0 1 1 2 0Z"
  />
  <path
    [attr.fill]="fillColor"
    d="M13.204 13.104V14h-3.32v-.896h1.12v-2.94a6.197 6.197 0 0 1 .016-.456l-.664.552a.411.411 0 0 1-.176.084.536.536 0 0 1-.16 0 .438.438 0 0 1-.136-.052.33.33 0 0 1-.088-.08l-.392-.52 1.816-1.524h1.024v4.936h.96Z"
  />
</svg>
